module.exports = __webpack_public_path__ + "assets/guide-img.59e96fd8.jpg";